import { Typo } from "../../Typo";

type LabelledValueProps = {
  label: string;
  value: string;
};

export const LabelledValue = ({ label, value }: LabelledValueProps) => (
  <div className="flex w-full flex-col gap-1">
    <Typo element="p" type="bodySM" textColor="text-text-secondary">
      {label}
    </Typo>
    <Typo element="p" type="labelMD" textColor="text-text-primary">
      {value}
    </Typo>
  </div>
);
